<div class="cliente-analise-mercado-classificacao-lancamento mb-3">
    <div class="card">
        <div class="card-header">
            <div class="card-header-title">
                <h6 class="card-title mb-0">Segmentos</h6>
            </div>
        </div>

        <ng-template [ngIf]="isLoading">
            <div class="card-body">
                <p class="text-muted m-0">
                    <i class='fas fa-spinner fa-pulse'></i> Carregando segmentos
                </p>
            </div>
        </ng-template>        

        <ng-template [ngIf]="!isLoading && entities">
            <ng-template [ngIf]="entities?.length > 0">
                <div class="table-responsive">
                    <table class="table table-striped table-hover table-bordered">
                        <thead>
                            <tr>
                                <th class="col-nome col-sticky row-span-2" rowspan="2" colspan="2"></th>
                                
                                <!-- <th class="col-status text-center" colspan="2">Status Lançamento</th> -->
                                <th class="col-status col-status-pretendido text-center row-span-2" rowspan="2">Status<br/>Pretendido</th>

                                <!-- <th class="col-lancamento row-span-2" rowspan="2">Lançamento</th> -->

                                <th class="col-quantidade text-center" [attr.colspan]="tableColspanQuantidade" *ngIf="configEmpresa?.controleQuantidade">Quantidade</th>
                                <th class="col-peso text-center" [attr.colspan]="tableColspanPeso" *ngIf="configEmpresa?.controlePeso">Peso</th>
                                <th class="col-valor text-center" [attr.colspan]="tableColspanValor" *ngIf="configEmpresa?.controleValor">Valor</th>
                            </tr>
                            <tr>
                                <!-- <th class="col-status col-status-pretendido text-center">Status Pretendido</th> -->
                                <!-- <th class="col-status col-status-projetado text-center">Projetado</th> -->
                                
                                <!-- Quantidade -->
                                <ng-template [ngIf]="configEmpresa?.controleQuantidade">
                                    <th class="col-quantidade col-quantidade-potencial text-right" *ngIf="configAnaliseMercado?.solicitarPotencial">Sell In Cliente</th>
                                    <th class="col-quantidade col-quantidade-pretendida text-right">Pretendida</th>
                                    <th class="col-quantidade col-quantidade-projetada text-right" *ngIf="showProjetado">Projetada</th>
                                    <th class="col-quantidade col-quantidade-un-realizada text-right">Realizada</th>
                                </ng-template>

                                <!-- Peso -->
                                <ng-template [ngIf]="configEmpresa?.controlePeso">
                                    <th class="col-peso col-peso-potencial text-right" *ngIf="configAnaliseMercado?.solicitarPotencial">Sell In Cliente</th>
                                    <th class="col-peso col-peso-pretendido text-right">Pretendido</th>
                                    <th class="col-peso col-peso-projetado text-right" *ngIf="showProjetado">Projetado</th>
                                    <th class="col-peso col-peso-realizado text-right">Realizado</th>
                                </ng-template>

                                <!-- Valor -->
                                <ng-template [ngIf]="configEmpresa?.controleValor">
                                    <th class="col-valor col-valor-potencial text-right" *ngIf="configAnaliseMercado?.solicitarPotencial">Sell In Cliente</th>
                                    <th class="col-valor col-valor-pretendido text-right">Pretendido</th>
                                    <th class="col-valor col-valor-projetado text-right" *ngIf="showProjetado">Projetado</th>
                                    <th class="col-valor col-valor-realizado text-right">Realizado</th>
                                </ng-template>
                            </tr>
                        </thead>

                        <tbody>
                            <tr *ngFor="let entity of entities; let last = last">
                                <td class="col-options col-sticky text-center">
                                    <span class="btn-group dropup table-options" sgtDropdownContainerBody *ngIf="entity.options?.hasAnyOption()">
                                        <button type="button" title="Opções" class="btn btn-link btn-options dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                            <i class="fas fa-ellipsis-h" aria-hidden="true"></i>
                                        </button>
                                        <div class="dropdown-menu">
                                            <a class="dropdown-item" *ngIf="entity.options?.canOpenLancamento" (click)="openLancamentoClick(entity)">
                                                <i class="fas fa-pencil-alt"></i> Abrir Lançamento
                                            </a>
                                            <a class="dropdown-item" *ngIf="entity.options?.canCreateLancamento" (click)="createLancamento(entity)">
                                                <i class="fas fa-plus"></i> Criar Lançamento
                                            </a>
                                            <ng-template [ngIf]="entity.options?.canDeleteLancamento">
                                                <div class="dropdown-divider" *ngIf="entity.options?.hasAnyOption()"></div>
                                                <a class="dropdown-item dropdown-item-delete" (click)="deleteLancamento(entity)">
                                                    <i class="far fa-trash-alt"></i> Excluir Lançamento
                                                </a>
                                            </ng-template>
                                        </div>
                                    </span>
                                </td>                                           
                                <td class="col-nome col-sticky">
                                    {{entity.classificacoesNome}}            
                                </td>

                                <td class="col-status col-status-pretendido text-center">
                                    <sgt-cliente-analise-mercado-status-pretendido-badge-pill
                                        [statusPretendido]="entity.statusPretendido">
                                    </sgt-cliente-analise-mercado-status-pretendido-badge-pill> 
                                </td>
                                <!-- <td class="col-status col-status-projetado text-center">
                                    <sgt-cliente-analise-mercado-status-projetado-badge-pill
                                        [statusProjetado]="entity.statusProjetado">
                                    </sgt-cliente-analise-mercado-status-projetado-badge-pill>
                                </td> -->

                                <!-- <td class="col-lancamento">
                                    {{entity.lancamento | lancamento}}
                                </td> -->

                                <!-- Quantidade -->
                                <ng-template [ngIf]="configEmpresa?.controleQuantidade">
                                    <td class="col-quantidade col-quantidade-potencial text-right" *ngIf="configAnaliseMercado?.solicitarPotencial">
                                        <ng-template [ngIf]="isLancamentoQuantidade(entity)">
                                            {{(entity.quantidadePotencial ? entity.quantidadePotencial : 0) | decimalFormat: 1:0:0}}
                                        </ng-template>
                                    </td>

                                    <td class="col-quantidade col-quantidade-pretendida text-right">
                                        <ng-template [ngIf]="isLancamentoQuantidade(entity)">
                                            {{(entity.quantidadePretendida ? entity.quantidadePretendida : 0) | decimalFormat: 1:0:0}}                    
    
                                            <div class="progress-container">
                                                <div class="progress-value">
                                                    {{entity.quantidadePretendidaPerc | decimalFormat: 1:0:0}}%
                                                </div>
                                                <div class="progress">
                                                    <div class="progress-bar" role="progressbar"
                                                        [style.width]="entity.quantidadePretendidaPerc + '%'"
                                                        [attr.aria-valuenow]="entity.quantidadePretendidaPerc" aria-valuemin="0" aria-valuemax="100">
                                                    </div>
                                                </div>
                                            </div>
                                        </ng-template>
                                    </td>                                    
                                    <td class="col-quantidade col-quantidade-projetada text-right" *ngIf="showProjetado">
                                        <ng-template [ngIf]="isLancamentoQuantidade(entity)">
                                            {{(entity.quantidadeProjetada ? entity.quantidadeProjetada : 0) | decimalFormat: 1:0:0}}                    
    
                                            <div class="progress-container">
                                                <div class="progress-value">
                                                    {{entity.quantidadeProjetadaPerc | decimalFormat: 1:0:0}}%
                                                </div>
                                                <div class="progress">
                                                    <div class="progress-bar" role="progressbar"
                                                        [style.width]="entity.quantidadeProjetadaPerc + '%'"
                                                        [attr.aria-valuenow]="entity.quantidadeProjetadaPerc" aria-valuemin="0" aria-valuemax="100">
                                                    </div>
                                                </div>
                                            </div>                                        
                                        </ng-template>                                        
                                    </td>
                                    <td class="col-quantidade col-quantidade-un-realizada text-right">
                                        {{entity.quantidadeRealizada | decimalFormat: 1:0:0}}

                                        <ng-template [ngIf]="isLancamentoQuantidade(entity)">
                                            <div class="progress-container">
                                                <div class="progress-value">
                                                    {{entity.quantidadeRealizadaPercPretendida | decimalFormat: 1:0:0}}%
                                                </div>
                                                <div class="progress">
                                                    <div class="progress-bar" role="progressbar"
                                                        [style.width]="entity.quantidadeRealizadaPercPretendida + '%'"
                                                        [attr.aria-valuenow]="entity.quantidadeRealizadaPercPretendida" aria-valuemin="0" aria-valuemax="100">
                                                    </div>
                                                </div>
                                            </div>                                        
                                        </ng-template>                                        
                                    </td>                                                                        
                                </ng-template>

                                <!-- Peso -->
                                <ng-template [ngIf]="configEmpresa?.controlePeso">
                                    <td class="col-peso col-peso-potencial text-right" *ngIf="configAnaliseMercado?.solicitarPotencial">
                                        <ng-template [ngIf]="isLancamentoPeso(entity)">
                                            {{(entity.pesoPotencial ? entity.pesoPotencial : 0) | decimalFormat: 1:0:0}}
                                        </ng-template>                                     
                                    </td>
                                    <td class="col-peso col-peso-pretendido text-right">
                                        <ng-template [ngIf]="isLancamentoPeso(entity)">
                                            {{(entity.pesoPretendido ? entity.pesoPretendido : 0) | decimalFormat: 1:0:0}}                    
    
                                            <div class="progress-container">
                                                <div class="progress-value">
                                                    {{entity.pesoPretendidoPerc | decimalFormat: 1:0:0}}%
                                                </div>
                                                <div class="progress">
                                                    <div class="progress-bar" role="progressbar"
                                                        [style.width]="entity.pesoPretendidoPerc + '%'"
                                                        [attr.aria-valuenow]="entity.pesoPretendidoPerc" aria-valuemin="0" aria-valuemax="100">
                                                    </div>
                                                </div>
                                            </div>
                                        </ng-template>                                        
                                    </td>
                                    <td class="col-peso col-peso-projetado text-right" *ngIf="showProjetado">
                                        <ng-template [ngIf]="isLancamentoPeso(entity)">
                                            {{(entity.pesoProjetado ? entity.pesoProjetado : 0) | decimalFormat: 1:0:0}}                    
    
                                            <div class="progress-container">
                                                <div class="progress-value">
                                                    {{entity.pesoProjetadoPerc | decimalFormat: 1:0:0}}%
                                                </div>
                                                <div class="progress">
                                                    <div class="progress-bar" role="progressbar"
                                                        [style.width]="entity.pesoProjetadoPerc + '%'"
                                                        [attr.aria-valuenow]="entity.pesoProjetadoPerc" aria-valuemin="0" aria-valuemax="100">
                                                    </div>
                                                </div>
                                            </div>                                        
                                        </ng-template>                                        
                                    </td>
                                    <td class="col-peso col-peso-realizado text-right">
                                        {{entity.pesoRealizado | decimalFormat: 1:0:0}}

                                        <ng-template [ngIf]="isLancamentoPeso(entity)">
                                            <div class="progress-container">
                                                <div class="progress-value">
                                                    {{entity.pesoRealizadoPercPretendido | decimalFormat: 1:0:0}}%
                                                </div>
                                                <div class="progress">
                                                    <div class="progress-bar" role="progressbar"
                                                        [style.width]="entity.pesoRealizadoPercPretendido + '%'"
                                                        [attr.aria-valuenow]="entity.pesoRealizadoPercPretendido" aria-valuemin="0" aria-valuemax="100">
                                                    </div>
                                                </div>
                                            </div>
                                        </ng-template>
                                    </td>
                                </ng-template>

                                <!-- Valor -->
                                <ng-template [ngIf]="configEmpresa?.controleValor">
                                    <td class="col-valor col-valor-potencial text-right" *ngIf="configAnaliseMercado?.solicitarPotencial">
                                        {{(entity.valorPotencial ? entity.valorPotencial : 0) | decimalFormat: 1:0:0}}                                   
                                    </td>
                                    <td class="col-valor col-valor-pretendido text-right">
                                        {{(entity.valorPretendido ? entity.valorPretendido : 0) | decimalFormat: 1:0:0}}
    
                                        <div class="progress-container">
                                            <div class="progress-value">
                                                {{entity.valorPretendidoPerc | decimalFormat: 1:0:0}}%
                                            </div>
                                            <div class="progress">
                                                <div class="progress-bar" role="progressbar"
                                                    [style.width]="entity.valorPretendidoPerc + '%'"
                                                    [attr.aria-valuenow]="entity.valorPretendidoPerc" aria-valuemin="0" aria-valuemax="100">
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                    <td class="col-valor col-valor-projetado text-right" *ngIf="showProjetado">
                                        {{(entity.valorProjetado ? entity.valorProjetado : 0) | decimalFormat: 1:0:0}}
    
                                        <div class="progress-container">
                                            <div class="progress-value">
                                                {{entity.valorProjetadoPerc | decimalFormat: 1:0:0}}%
                                            </div>
                                            <div class="progress">
                                                <div class="progress-bar" role="progressbar"
                                                    [style.width]="entity.valorProjetadoPerc + '%'"
                                                    [attr.aria-valuenow]="entity.valorProjetadoPerc" aria-valuemin="0" aria-valuemax="100">
                                                </div>
                                            </div>
                                        </div>
                                    </td>                                 
                                    <td class="col-valor col-valor-realizado text-right">
                                        {{entity.valorRealizado | decimalFormat: 1:0:0}}
    
                                        <div class="progress-container">
                                            <div class="progress-value">
                                                {{entity.valorRealizadoPercPretendido | decimalFormat: 1:0:0}}%
                                            </div>
                                            <div class="progress">
                                                <div class="progress-bar" role="progressbar"
                                                    [style.width]="entity.valorRealizadoPercPretendido + '%'"
                                                    [attr.aria-valuenow]="entity.valorRealizadoPercPretendido" aria-valuemin="0" aria-valuemax="100">
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                </ng-template>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="card-footer">
                    <button type="button" class="btn btn-primary btn-sm mr-2" (click)="createLancamentoModal()">
                        <i class="fas fa-plus" aria-hidden="true"></i> Adicionar Segmento
                    </button>
                </div>                            
            </ng-template>

            <ng-template [ngIf]="!entities || entities.length === 0">
                <div class="alert alert-info alert-cliente-analise-mercado-classificacao-empty" role="alert">
                    <h4 class="alert-cliente-analise-mercado-classificacao-empty-title">
                        <i class="fas fa-info" aria-hidden="true"></i>
                        Nenhum segmento adicionado
                    </h4>

                    <button type="button" class="btn btn-primary btn-sm mr-2" (click)="createLancamentoModal()">
                        <i class="fas fa-plus" aria-hidden="true"></i> Começar a adicionar segmentos
                    </button>
                </div>
            </ng-template>
        </ng-template>
    </div>
</div>

<!-- Create Modal -->
<sgt-cliente-analise-mercado-lancamento-create-modal
    #createModal
    (afterCreate)="onAfterCreateLancamento($event)">
</sgt-cliente-analise-mercado-lancamento-create-modal>